import React, { useMemo } from "react";

function RemainingItemsByDelivery({ shipments = [], deliveryPeople = [] }) {
  const remainingItems = useMemo(() => {
    return shipments.filter((item) => {
      const hasEmptyStatus =
        !item.ourStat || item.ourStat.trim() === "";

      const hasValidDeliveryPerson =
        item.deliveryPerson &&
        deliveryPeople.includes(item.deliveryPerson);

      return hasEmptyStatus && hasValidDeliveryPerson;
    });
  }, [shipments, deliveryPeople]);

  const countByPerson = useMemo(() => {
    const counts = {};
    deliveryPeople.forEach((p) => (counts[p] = 0));

    remainingItems.forEach((item) => {
      counts[item.deliveryPerson]++;
    });

    return counts;
  }, [remainingItems, deliveryPeople]);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">
        Remaining Unshipped Phones
      </h1>

      <table className="w-full border-collapse table-auto">
        <thead>
          <tr>
            {deliveryPeople.map((person) => (
              <th key={person} className="border px-4 py-2">
                {person}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {deliveryPeople.map((person) => (
              <td
                key={person}
                className="border px-4 py-2 text-center font-semibold"
              >
                {countByPerson[person]}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default RemainingItemsByDelivery;
